import getWindow from "../../utils/window";

const getAsosWorldTier = (tierNumber, tierName) => {
  let asosWorldTier = "";
  if (parseInt(tierNumber) > 0) {
    asosWorldTier = `${tierName.toLowerCase()} ${tierNumber}`;
  } else {
    asosWorldTier = "pre opt in";
  }
  return asosWorldTier;
};

export default function setMembersDayTracking({ tierNumber, tierName }) {
  const s = getWindow().s;
  s.eVar229 = "members day";
  s.eVar145 = getAsosWorldTier(tierNumber, tierName);
}
